export default {
  filters: {
    rfqFormat(value) {
      return value.toString().padStart(6, 0);
    },
  },
};
